<div class="row">
  <div class="col-md-12">
    <h3>Line Items</h3>
  </div>
</div>

<!-- <div *ngIf="edit" class="row">
  <div class="col-md-12" style="text-align: right">
    <button class="btn btn-success btn-md" (click)="actionLineItems('create')">
      <i class="material-icons">add</i>
      &nbsp; New Line Item
    </button>
  </div>
</div> -->

<br /><br />

<!-- <div *ngIf="edit" class="row">
  <div class="col-md-12" style="text-align: right">
    <button
      class="btn btn-sm btn-danger"
      [disabled]="!checkReserveAny() || loadingUnreserveAll || loadingUnreserve"
      (click)="unreserveAll()"
    >
      <i
        *ngIf="loadingUnreserveAll"
        class="fa fa-circle-o-notch fa-spin fa-fw"
      ></i>
      &nbsp; Unreserve All
    </button>

    &nbsp;

    <button
      class="btn btn-sm btn-default"
      [disabled]="
        arrayUnreserve.length === 0 || loadingUnreserve || loadingUnreserveAll
      "
      (click)="unreserve()"
    >
      <i
        *ngIf="loadingUnreserve"
        class="fa fa-circle-o-notch fa-spin fa-fw"
      ></i>
      &nbsp; Unreserve Selected
    </button>
  </div>
</div> -->

<div *ngIf="loading">
  <div class="row" style="text-align: center">
    <div class="col-12">
      <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></b></h2>
    </div>
  </div>
</div>

<div *ngIf="!loading">

  <div class="row" style="font-size: 15px">
    <div class="col-md-2">
      <strong>Item</strong>
    </div>
    <div class="col-md-2">
      <strong>Condition</strong>
    </div>
    <div class="col-md-1">
      <strong>QTY.</strong>
    </div>
    <div class="col-md-1">
      <strong>Unit Price</strong>
    </div>
    <div class="col-md-1">
      <strong>AVG</strong>
    </div>
    <div class="col-md-1">
      <strong>Profit</strong>
    </div>
    <div class="col-md-4" style="text-align: right">
      <strong>Actions</strong>
    </div>
  </div>

  <div *ngFor="let item of lineItems; let i = index">
    <div
      class="row item-rwo {{ parImpar(i) ? 'item-rwo-par' : 'item-rwo-impar' }}"
    >
      <div class="col-md-2">
        <label style="margin-top: 15px; color: black">
          {{ item.item }}
        </label>
      </div>
      <div class="col-md-2">
        <label style="margin-top: 15px; color: black">
          {{rCondition(item.condition) | titlecase}}
      </label>
      </div>
      <div class="col-md-1">
        <label
          *ngIf="
            item.type === 'Inventory' &&
            (!checkEditLineItem(item.id) || typeChange !== 'quantity')
          "
          style="margin-top: 15px; color: black"
          (dblclick)="editLineItem(item.id, item.quantity, 'quantity', i)"
        >
          {{ item.reservedInventories.length }}/{{ item.quantity }}
        </label>
        <label
          *ngIf="
            item.type === 'ScrapInventory' &&
            (!checkEditLineItem(item.id) || typeChange !== 'height')
          "
          style="margin-top: 15px; color: black"
          (dblclick)="editLineItem(item.id, item.height, 'height', i)"
        >
          {{ item.height }}
        </label>

        <input
          *ngIf="typeChange === 'quantity' && checkEditLineItem(item.id)"
          type="text"
          class="form-control"
          [name]="'itemquantity' + item.id"
          [(ngModel)]="item.quantity"
          (blur)="saveEditItem(item.quantity)"
          (keyup.enter)="saveEditItem(item.quantity)"
        />
        <input
          *ngIf="typeChange === 'height' && checkEditLineItem(item.id)"
          type="text"
          class="form-control"
          [name]="'itemheight' + item.id"
          [(ngModel)]="item.height"
          (blur)="saveEditItem(item.height)"
          (keyup.enter)="saveEditItem(item.quantity)"
        />
      </div>
      <div class="col-md-1">
        <label
          *ngIf="!checkEditLineItem(item.id) || typeChange !== 'unitprice'"
          style="margin-top: 15px; color: black"
          (dblclick)="editLineItem(item.id, item.unitPrice, 'unitprice', i)"
        >
          {{ item.unitPrice | number: ".2-2" }}
        </label>

        <input
          *ngIf="typeChange === 'unitprice' && checkEditLineItem(item.id)"
          type="text"
          class="form-control"
          [name]="'itemunitPrice' + item.id"
          [(ngModel)]="item.unitPrice"
          (blur)="saveEditItem(item.unitPrice)"
          (keyup.enter)="saveEditItem(item.unitPrice)"
        />
      </div>
      <div class="col-md-1">
        <label style="margin-top: 15px; color: black">
          {{ item.reservedInventories.length }}
        </label>
      </div>
      <div class="col-md-1">
        <label style="margin-top: 15px; color: black">
          {{
            item.unitPrice * item.reservedInventories.length -
              totalCost(item.reservedInventories) | number: ".2-2"
          }}
        </label>
      </div>
      <div class="col-md-4" style="text-align: right">
        <a
          *ngIf="inTransit(i) > 0"
          class="btn btn-link btn-warning btn-just-icon"
          matTooltip="{{ inTransit(i) }} In Transit"
        >
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </a>
  
        <button
          *ngIf="item.type === 'Inventory'"
          class="btn btn-sm btn-{{
            item.reservedInventories.length < item.quantity
              ? 'warning'
              : 'success'
          }}"
          [disabled]="(item.reservedInventories.length >= item.quantity) || !edit"
          (click)="openReserveModal(item, i)"
        >
          <i class="fa fa-share-square-o" aria-hidden="true"></i> &nbsp; Reserve
        </button>
  
        <a
          *ngIf="item.type === 'Inventory' && item.reservedInventories.length > 0"
          data-toggle="collapse"
          href="#colapse{{ i }}"
          (click)="item.show = !item.show"
          class="btn btn-link btn-{{
            item.show ? 'danger' : 'success'
          }} btn-just-icon"
        >
          <i class="material-icons">
            {{ item.show ? "remove_circle" : "add_circle" }}
          </i>
        </a>
  
        <!-- <a
          *ngIf="
            !checkEditLineItem(item.id) && item.reservedInventories.length === 0
          "
          class="btn btn-link btn-primary btn-just-icon"
          (click)="editLineItem(item.id)"
        >
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </a> -->
  
        <!-- <button
          *ngIf="
            checkEditLineItem(item.id) && item.reservedInventories.length === 0
          "
          class="btn btn-link btn-primary btn-just-icon"
          (click)="saveEditItem()"
          [disabled]="savingEditItem"
        >
          <i
            *ngIf="!savingEditItem"
            class="fa fa-floppy-o"
            aria-hidden="true"
          ></i>
          <i
            *ngIf="savingEditItem"
            class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
          ></i>
        </button> -->
  
        <a
          *ngIf="item.reservedInventories.length == 0"
          class="btn btn-link btn-danger btn-just-icon"
          (click)="eliminarLineItem(i)"
        >
          <i class="material-icons">close</i>
        </a>
      </div>
    </div>
  
    <div
      *ngIf="item.type === 'Inventory' && item.reservedInventories.length > 0"
      id="colapse{{ i }}"
      class="collapse"
    >
      <div class="row">
        <div class="col-12">
          <div class="material-datatables">
            <table
              id="table{{ i }}"
              class="table table-striped table-no-bordered table-hover"
              cellspacing="0"
              width="100%"
              style="width: 100%"
            >
              <thead>
                <tr>
                  <th>
                    <a
                      class="btn btn-link btn-primary btn-just-icon"
                      (click)="pushAllItemUnreserve(i)"
                    >
                      <i class="material-icons">{{
                        checkAllUnreserve(i)
                          ? "check_box"
                          : "check_box_outline_blank"
                      }}</i>
                    </a>
                  </th>
                  <th style="cursor: pointer" (click)="orderBy(i, 'line')">
                    <i
                      *ngIf="item.order != 'line'"
                      class="fa fa-sort"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'line' && item.ordenar"
                      class="fa fa-sort-asc"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'line' && !item.ordenar"
                      class="fa fa-sort-desc"
                      aria-hidden="true"
                    ></i>
                    Line
                  </th>
                  <th style="cursor: pointer" (click)="orderBy(i, 'po')">
                    <i
                      *ngIf="item.order != 'po'"
                      class="fa fa-sort"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'po' && item.ordenar"
                      class="fa fa-sort-asc"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'po' && !item.ordenar"
                      class="fa fa-sort-desc"
                      aria-hidden="true"
                    ></i>
                    PO
                  </th>
                  <th style="cursor: pointer" (click)="orderBy(i, 'sn')">
                    <i
                      *ngIf="item.order != 'sn'"
                      class="fa fa-sort"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'sn' && item.ordenar"
                      class="fa fa-sort-asc"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'sn' && !item.ordenar"
                      class="fa fa-sort-desc"
                      aria-hidden="true"
                    ></i>
                    Serial Number
                  </th>
                  <th style="cursor: pointer" (click)="orderBy(i, 'wh')">
                    <i
                      *ngIf="item.order != 'wh'"
                      class="fa fa-sort"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'wh' && item.ordenar"
                      class="fa fa-sort-asc"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'wh' && !item.ordenar"
                      class="fa fa-sort-desc"
                      aria-hidden="true"
                    ></i>
                    Warehouse
                  </th>
                  <th style="cursor: pointer" (click)="orderBy(i, 'status')">
                    <i
                      *ngIf="item.order != 'status'"
                      class="fa fa-sort"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'status' && item.ordenar"
                      class="fa fa-sort-asc"
                      aria-hidden="true"
                    ></i>
                    <i
                      *ngIf="item.order == 'status' && !item.ordenar"
                      class="fa fa-sort-desc"
                      aria-hidden="true"
                    ></i>
                    Rec. Status
                  </th>
                  <!-- <th>Cond</th> -->
                  <th>Description</th>
                  <th></th>
                </tr>
              </thead>
              <tbody *ngFor="let reserve of item.reservedInventories">
                <tr>
                  <td>
                    <a
                      class="btn btn-link btn-info btn-just-icon"
                      (click)="pushUnreserve(reserve.id)"
                    >
                      <i class="material-icons">{{
                        checkUnreserve(reserve.id)
                          ? "check_box"
                          : "check_box_outline_blank"
                      }}</i>
                    </a>
                  </td>
                  <td>{{ reserve.soLine }}</td>
                  <td> {{reserve.po ? reserve.po.po + ' ' + reserve.poline : ''}} <!--{{ reserve.po.po }}-{{ reserve.poline }}--></td>
                  <td>{{ reserve.serialnumber }}</td>
                  <td>{{ reserve.warehouse }}</td>
                  <td>{{ reserve.receivestatus }}</td>
                  <!-- <td>{{reserve.conditioninventory}}</td> -->
                  <td *ngIf="reserve.status == 'Reserved'">
                    <span
                      class="bmd-form-group"
                      *ngIf="checkEditDescription(reserve.id)"
                    >
                      <div class="input-group">
                        <textarea
                          name="descr{{ reserve.id }}"
                          #descr="ngModel"
                          [(ngModel)]="reserve.itemdesc"
                          class="form-control"
                          rows="3"
                        ></textarea>
                        <div class="input-group-prepend">
                          <button
                            *ngIf="descr.dirty"
                            class="
                              input-group-text
                              btn btn-link btn-primary btn-just-icon
                            "
                            (click)="
                              saveDescription(descr, reserve.id, reserve.itemdesc)
                            "
                          >
                            <i
                              *ngIf="savingDescription !== reserve.id"
                              class="fa fa-floppy-o"
                              aria-hidden="true"
                            ></i>
                            <i
                              *ngIf="savingDescription === reserve.id"
                              class="fa fa-circle-o-notch fa-spin fa-fw"
                            ></i>
                          </button>
                          <button
                            *ngIf="savingDescription !== reserve.id"
                            class="
                              input-group-text
                              btn btn-link btn-primary btn-just-icon
                            "
                            (click)="
                              reserve.itemdesc = cancelEditDescirption(reserve.id)
                            "
                          >
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </span>
  
                    <span
                      class="bmd-form-group"
                      *ngIf="!checkEditDescription(reserve.id)"
                    >
                      <div class="input-group">
                        <textarea
                          name="descr{{ reserve.id }}"
                          #editando="ngModel"
                          [(ngModel)]="reserve.itemdesc"
                          class="form-control"
                          rows="3"
                          disabled
                        ></textarea>
                        <div class="input-group-prepend">
                          <button
                            class="
                              input-group-text
                              btn btn-link btn-primary btn-just-icon
                            "
                            [disabled]="savingDescription === reserve.id"
                            (click)="
                              editDescription(reserve.id, reserve.itemdesc)
                            "
                          >
                            <i
                              *ngIf="savingDescription !== reserve.id"
                              class="fa fa-pencil"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </span>
                  </td>
                  <td *ngIf="reserve.status == 'Reserved'">
                    <a
                          class="btn btn-link btn-info btn-just-icon"
                          (click)="showItem(reserve.id)"
                        >
                          <i class="material-icons">remove_red_eye</i>
                        </a>
                  </td>
                  <td *ngIf="reserve.status != 'Reserved'">
                    <div class="row">
                      <div class="col-md-10">
                        <div class="alert alert-danger" role="alert">
                          <strong>Important:</strong> this item is not reserved,
                          please delete it.
                        </div>
                      </div>
                      <div class="col-md-2" style="text-align: right">
                        <a
                          class="btn btn-link btn-info btn-just-icon"
                          (click)="showItem(reserve.id)"
                        >
                          <i class="material-icons">remove_red_eye</i>
                        </a>
                        <a
                          class="btn btn-link btn-danger btn-just-icon"
                          (click)="unreserve(reserve.id)"
                        >
                          <i class="material-icons">close</i>
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="myModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" style="width:85% !important; max-width: 1024px;">
    <div class="modal-content">

      <div class="modal-header">
    
          <div class="row" style="width: 100%;" *ngIf="selectedLineItem !== null">
            <div class="col-md-9">
              <h3>
                <b *ngIf="lineItem.type == 'Inventory'">
                  Adding: {{lineItem.item}}
                </b>
                <b *ngIf="lineItem.type == 'ScrapInventory'">
                  Adding Scrap Element: #{{lineItem.item}}
                </b>
              </h3> 
              <hr>
               
            </div>
            <div *ngIf="lineItem.type == 'Inventory'" class="col-md-3">
              <div class="form-group">
                <label class="bmd-label-floating">Stock</label>
                <input type="text" name="stockheader" [(ngModel)]="stock" class="form-control" readonly>
              </div>
            </div>

            <hr>
          </div>
       
      </div>

      <div class="modal-body">

        <form #f2='ngForm'>

          <div class="row" *ngIf="selectedLineItem !== null">
            <div class="col-md-2">
              <div class="form-group">
                <label class="bmd-label-floating">SO</label>
                <input type="text" name="SOI" [(ngModel)]="lineItem.SO" class="form-control" readonly>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="bmd-label-floating">Manufacturer</label>
                <input type="text" name="manufacturer" [(ngModel)]="lineItem.manufacturer" class="form-control" readonly>
                <!-- <select name="manufacturer" [(ngModel)]="lineItem.manufacturer" class="form-control" [disabled]="!edit" required>
                    <option value="null"></option>
                    <option *ngFor="let item of manufacturers" [value]="item.id">{{item.name}}</option>
                </select> -->
              </div>
            </div>
          </div>

          <div *ngIf="selectedLineItem !== null">

            <br ><hr>
            
            <div class="row">
              <div class="col-md-12">
                <h4>
                  Pricing
                </h4>
              </div>
            </div>

            <div class="row">
              <div *ngIf="lineItem.type == 'Inventory'" class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">Quantity</label>
                  <input type="number" max="stock" name="quantity" class="form-control" (change)="calcularTotal()" [(ngModel)]="lineItem.quantity">
                
                </div>
                <span *ngIf="lineItem.quantity > stock" style="color: red;">
                  insufficient stocks
                </span>
              </div>
              <div *ngIf="lineItem.type == 'ScrapInventory'" class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">Heigth</label>
                  <input type="text" name="height" class="form-control" [(ngModel)]="lineItem.height" disabled>
                
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">Unit Price</label>
                  <input type="number" name="unitPrice" class="form-control" (change)="calcularTotal()" [(ngModel)]="lineItem.unitPrice">
                </div>
              </div>
              <div class="col-md-4">

                <div *ngIf="lineItem.type == 'Inventory'" class="form-group">
                  <label class="bmd-label-floating">Condition</label>
                  <select name="condition" class="form-control" [(ngModel)]="lineItem.condition">
                    <option value=""></option>
                    <option *ngFor="let item of conditions" [value]="item.id">{{item.name}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="bmd-label-floating">Total</label>
                  <input type="number" name="extendedPrice" class="form-control" [(ngModel)]="lineItem.total" readonly>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Internal Comments</label>
                  <textarea name="internalComments" class="form-control" [(ngModel)]="lineItem.internalComments" cols="5" rows="3"></textarea>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Comments to Customer</label>
                  <textarea name="commentsToCustomer" class="form-control" [(ngModel)]="lineItem.commentsToCustomer" cols="5" rows="3"></textarea>
                </div>
              </div>
            </div>

          </div>
          
          <div *ngIf="selectedLineItem === null">

            <div class="row" style="display: flex; align-items: center; justify-content: center;">
              <div class="py-4" style="margin: 0 5px; padding: 30px; width: 22%;" (click)="lineItem.type = 'Inventory'" [ngClass]="{'selected': lineItem.type == 'Inventory', 'option': lineItem.type != 'Inventory'}">
      
                <strong style="font-size: 17px;"> <span class="material-icons">list_alt</span> &nbsp; Inventory</strong>
                  
              </div>
              <div class="py-4" style="margin: 0 5px; padding: 30px;  width: 22%;" (click)="lineItem.type = 'Bulk'" [ngClass]="{'selected': lineItem.type == 'Bulk', 'option': lineItem.type != 'Bulk'}">
                
                <strong style="font-size: 17px;"> <span class="material-icons">scatter_plot</span> &nbsp; Bulk</strong>
                  
              </div>
              <div class="py-4" style="margin: 0 5px; padding: 30px;  width: 22%;" (click)="lineItem.type = 'NoInventory'" [ngClass]="{'selected': lineItem.type == 'NoInventory', 'option': lineItem.type != 'NoInventory'}">
                
                <strong style="font-size: 17px;"> <span class="material-icons">desktop_access_disabled</span> &nbsp; No Inventory</strong>
                  
              </div>
              <div class="py-4" style="margin: 0 5px; padding: 30px; width: 22%;" (click)="lineItem.type = 'ScrapInventory'" [ngClass]="{'selected': lineItem.type == 'ScrapInventory', 'option': lineItem.type != 'ScrapInventory'}">
                
                <strong style="font-size: 17px;"> <span class="material-icons">delete</span> &nbsp; Scrap Inventory</strong>
                  
              </div>
            </div>
            
            <div class="row" *ngIf="lineItem.type == 'Inventory'">
              <div class="col-md-12">
                <app-filter-line-items (select)="selectLineItem($event)"></app-filter-line-items>
              </div>
            </div>

            <div class="row" *ngIf="lineItem.type == 'ScrapInventory'">
              <div class="col-md-12">
                <app-filter type="SCRAP" class="ion-margin-top" (select)="selectScrap($event)"></app-filter>
              </div>
            </div>
            
          </div>

        </form>

        <br><br>
        <div class="row">
          <div class="col-md-6">

            <button type="button" class="btn btn-default btn-md" (click)="closeModal()">
              Cancel
            </button> 

          </div>
          <div class="col-md-6" style="text-align: right;">

            <button *ngIf="selectedLineItem !== null" type="button" class="btn btn-success btn-md" (click)="agregarLineItem()" [disabled]="saving || (lineItem.type == 'Inventory' && lineItem.quantity < 1)">
              Add
            </button>

          </div>
        </div>
        
      </div>

    </div>
  </div>
</div>







<div class="modal fade" id="reserveModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" style="width:85% !important; max-width: 2048px;">
    <div class="modal-content">

      <div class="modal-header">
        <h3>
          <b>Reserve</b>
        </h3>
      </div>


      <div class="modal-body">

        <div *ngIf="loadingReserve" class="row" style="text-align: center">
          <div class="col-12">
            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
          </div>
        </div>

        <div *ngIf="!loadingReserve">

          <div class="row">

            <div class="col-md-2">
              <label class="bmd-label-floating">SO</label>
              <input type="text" class="form-control" name="sliso" #sliso="ngModel" [(ngModel)]="serveLineItem.so" readonly>
            </div>

            <div class="col-md-1">
              <label class="bmd-label-floating">Rep</label>
              <input type="text" class="form-control" name="slirep" #slirep="ngModel" [(ngModel)]="serveLineItem.rep" readonly>
            </div>

            <div class="col-md-3">
              <label class="bmd-label-floating">Item</label>
              <input type="text" class="form-control" name="slirep" #slirep="ngModel" [(ngModel)]="serveLineItem.item" readonly>
            </div>

            <div class="col-md-1">
              <!-- <label class="bmd-label-floating"></label>
              <label>
                <input type="checkbox"  name="slibulk" #slibulk="ngModel" [(ngModel)]="serveLineItem.bulk"> Bulk
              </label> -->
            </div>

            <div class="col-md-1">
              <label class="bmd-label-floating">MFGR</label>
              <input type="text" class="form-control" name="slimfgr" #slimfgr="ngModel" [(ngModel)]="serveLineItem.mfgr" readonly>
            </div>

            <div class="col-md-2">
              <label class="bmd-label-floating">Condition</label>
              <input type="text" class="form-control" name="slicondition" [value]="rCondition(serveLineItem.condition)" readonly>
            </div>

            <div class="col-md-2">
              <label class="bmd-label-floating">Selling Price</label>
              <input type="text" class="form-control" name="sliselliongPrice" #sliselliongPrice="ngModel" [(ngModel)]="serveLineItem.sellingPrice" readonly>
            </div>

          </div>

          <br>

          <div class="row">

            <div class="col-md-2">
              <label class="bmd-label-floating"></label>
              <label>
                <input type="checkbox"  name="slishowInTransitItems" #slishowInTransitItems="ngModel" [(ngModel)]="serveLineItem.showInTransitItems"> Show In Transit Items
              </label>
            </div>

            <!-- <div class="col-md-2">
              <label class="bmd-label-floating"></label>
              <label>
                <input type="checkbox"  name="slishowItemSubstitutea" #slishowItemSubstitutea="ngModel" [(ngModel)]="serveLineItem.showItemSubstitutea"> Show Items Substitutes
              </label>
            </div> -->

            <div class="col-md-2">
              <label class="bmd-label-floating"></label>
              <label>
                <input type="checkbox"  name="slishowAllConditionsCodes" #slishowAllConditionsCodes="ngModel" [(ngModel)]="serveLineItem.showAllConditionsCodes"> Show All Conditions Codes
              </label>
            </div>

          </div>

          <br>
          
          <div class="row">
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-12" style="text-align: center; margin-left: 5px;">
                  <strong >Available Inventory Summary</strong>
                </div>
              </div>
              <div class="material-datatables" style="height:315px; overflow:auto;">
                <table id="LinesAgrupados" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%;">
                  <thead>
                    <tr>
                        <th><b>PO</b></th>
                        <th><b>Item</b></th>
                        <th><b>Unit Cost</b></th>
                        <th><b>Codition</b></th>
                        <th><b>Qty.</b></th>
                        <th style="text-align: center;"> <b>Mark</b> </th>
                        <th><b>Rec Status</b></th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let group of agrupados">
                    <tr *ngIf="(serveLineItem.showAllConditionsCodes || group.conditioninventory == rCondition(serveLineItem.condition)) && (serveLineItem.showInTransitItems || group.receivestatus != 'In Transit')">
                      <td>{{group.po.po}}</td>
                      <td>{{group.item}}</td>
                      <td>{{group.unitcost}}</td>
                      <td>{{group.conditioninventory}}</td>
                      <td>{{agrupadosQty[group.conditioninventory]}}</td>
                      <td style="text-align: center;">
                        <!-- <input type="checkbox" class="form-control" [checked]="check()" (change)="checar($event)"> -->
                        <!-- <mat-checkbox name="group" (change)="checar($event)" [checked]="check()"></mat-checkbox> -->
                        <a class="btn btn-link btn-just-icon" (click)="checarGroup(group.conditioninventory, !check(group.conditioninventory))"> 
                          <i *ngIf="!check(group.conditioninventory)" class="material-icons" style="color: black;">check_box_outline_blank</i>
                          <i *ngIf="check(group.conditioninventory)" class="material-icons" style="color: blue;">check_box</i>
                        </a>
                      </td>
                      <td>{{group.receivestatus}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-3">

              <div class="row">
                <div class="col-md-12">
                  <label class="bmd-label-floating">Qty. To Reserve</label>
                  <input type="number" (keypress)="mtds.onlyNumber($event)" class="form-control" name="sliqtyToReserve" #sliqtyToReserve="ngModel" [(ngModel)]="serveLineItem.qtyToReserve" readonly>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label class="bmd-label-floating">Marked</label>
                  <input type="number" (keypress)="mtds.onlyNumber($event)" class="form-control" name="slimarked" [value]="serveLineItem.marked" readonly>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label class="bmd-label-floating">Balance to Reserve</label>
                  <input type="number" (keypress)="mtds.onlyNumber($event)" class="form-control" name="slibalanceToReserve" [value]="(serveLineItem.qtyToReserve - serveLineItem.marked)" readonly>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4" style="text-align: right; margin-top: 10px;">
                  <label class="bmd-label-floating">Mark First</label>
                </div>
                <div class="col-md-2">
                  <input type="number" (keypress)="mtds.onlyNumber($event)" min="1" class="form-control" name="slimarkFirst" #slimarkFirst="ngModel" [(ngModel)]="serveLineItem.markFirst">
                </div>
                <div class="col-md-6" style="margin-top: 10px;">
                  <label class="bmd-label-floating">Items in the Grid</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6" style="text-align: center;">
                  <button class="btn btn-default btn-sm">
                    Mark
                  </button>
                </div>
                <div class="col-md-6" style="text-align: center;">
                  <button class="btn btn-default btn-sm">
                    Clear Mark
                  </button>
                </div>
              </div>
              
            </div>
          </div>

          <div class="row">
            <div class="col-md-12" style="text-align: center; background-color: #D6DBDF; margin-left: 5px;">
              <strong style="font-size: 20px;">Available Inventory Detail</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="material-datatables" style="height:315px; overflow:auto;">
                <table id="LinesAgrupados" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%;">

                  <thead>
                    <tr>
                      <th><b>Id</b></th>
                        <th><b>PO</b></th>
                        <th><b>Item</b></th>
                        <th><b>Serial Number</b></th>
                        <th><b>Mfgr</b></th>
                        <th><b>Warehouse</b></th>
                        <th><b>Cost</b></th>
                        <th><b>Buyer</b></th>
                        <th><b>Cond</b></th>
                        <th><b>Rec. Status</b></th>
                        <th><b>Qty.</b></th>
                        <th style="text-align: right;"> <b>Mark</b> </th>
                        <th><b>Location</b></th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let item of individuales">
                    <tr *ngIf="(serveLineItem.showAllConditionsCodes || item.conditioninventory == rCondition(serveLineItem.condition)) && (serveLineItem.showInTransitItems || item.receivestatus != 'In Transit')">
                      <td>{{item.id}}</td>
                      <td>{{item.po.po}}</td>
                      <td>{{item.item}}</td>
                      <td>{{item.serialnumber}}</td>
                      <td>{{item.mfgr}}</td>
                      <td>{{item.warehouse}}</td>
                      <td>{{item.unitcost}}</td>
                      <td>{{item.rep}}</td>
                      <td>{{item.conditioninventory}}</td>
                      <td>{{item.receivestatus}}</td>
                      <td>{{item.quantity}}</td>
                      <td>
                        <a class="btn btn-link btn-just-icon" (click)="checarId(item.id)">
                          <i *ngIf="!checkId(item.id)" class="material-icons" style="color: black;">check_box_outline_blank</i>
                          <i *ngIf="checkId(item.id)" class="material-icons" style="color: blue;">check_box</i>
                        </a>
                      </td>
                      <td>{{item.location}}</td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>

        </div>


        <div *ngIf="errorArray.length > 0" class="row">
          <div class="col-md-12">
            <div class="alert alert-danger">
              The following items have already been reserved by another user: <br>
              <strong *ngFor="let error of errorArray">{{error.item}}, </strong>
            </div>
          </div>
        </div>

        <br><br><br>
        <div class="row">
          <div class="col-md-6">

            <button type="button" class="btn btn-default btn-md" (click)="closeReserveModal()">
              Cancel
            </button>

          </div>
          <div class="col-md-6" style="text-align: right;">

            <button type="button" class="btn btn-success btn-md" (click)="reserve()" [disabled]="loadingReserve || loadingUnreserve">
              <i *ngIf="!loadingReserve" class="fa fa-share-square-o" aria-hidden="true"></i>
              <i class="fa fa-circle-o-notch fa-spin fa-fw" *ngIf="loadingReserve || saving"></i> &nbsp; Reserve
            </button>

          </div>
        </div>

      </div>

    </div>
  </div>
</div>